import Keycloak from "keycloak-js";
import router from "@/router/index";
import store from "@/store";
import {
  KEYCLOAK_URL,
  KEYCLOAK_REALM,
  KEYCLOAK_CLIENT_ID,
  VUE_APP_ENABLE_REGULAMENTOS,
} from "@/env";

const showModalRegulamentos =
  process.env.NODE_ENV === "production"
    ? VUE_APP_ENABLE_REGULAMENTOS === "true"
    : process.env.VUE_APP_ENABLE_REGULAMENTOS === "true";

function getRegulamentos() {
  if (!showModalRegulamentos) return;
  store.dispatch("regulamentos/getVersaoAndDtCriacao");
}

const keycloak = new Keycloak({
  url:
    process.env.NODE_ENV === "production"
      ? KEYCLOAK_URL
      : process.env.VUE_APP_API_KEYCLOAK_URL,
  realm:
    process.env.NODE_ENV === "production"
      ? KEYCLOAK_REALM
      : process.env.VUE_APP_API_KEYCLOAK_REALM,
  clientId:
    process.env.NODE_ENV === "production"
      ? KEYCLOAK_CLIENT_ID
      : process.env.VUE_APP_API_KEYCLOAK_CLIENT,
});

keycloak.init({
  onLoad: "login-required",
  checkLoginIframe: false,
});

keycloak.onAuthSuccess = async () => {
  store.dispatch("auth/loadSession").catch((error) => {
    console.log("Error", error);
    if (router.currentRoute.path !== "/login") router.push("/login");
  });

  getRegulamentos();

  if (store.getters["auth/isAuthenticated"]) {
    if (router.currentRoute.path !== "/login") {
      router.push(router.currentRoute.path);
    } else {
      router.push("/home");
    }
  }
};

keycloak.onAuthRefreshSuccess = () => {
  console.log("Keycloak On Auth Refresh Success");
};

keycloak.onAuthRefreshError = () => {
  console.log("Keycloak On Auth Refresh Error");
  store.dispatch("auth/logout");
};

keycloak.onAuthLogout = () => {
  console.log("Keycloak On Auth Logout");
};

keycloak.onAuthError = () => {
  console.log("Keycloak On Auth Error");
  store.dispatch("auth/failExternalLogin");
};

keycloak.onTokenExpired = () => {
  console.log("Keycloak On Token expired");
  store.dispatch("auth/tryRefreshToken");
};

export default keycloak;
